export const REGISTER_DEVICE = 'REGISTER_DEVICE';
export const REGISTER_DEVICE_SUCCESS = 'REGISTER_DEVICE_SUCCESS';

export const MOBILE_LOGIN = 'MOBILE_LOGIN';
export const MOBILE_LOGIN_SUCCESS = 'MOBILE_LOGIN_SUCCESS';

export const RESET_DEVICE = 'RESET_DEVICES';
export const RESET_DEVICE_SUCCESS = 'RESET_DEVICE_SUCCESS';

export const GET_DEVICES = 'GET_DEVICES';
export const GET_DEVICES_SUCCESS = 'GET_DEVICES_SUCCESS';

export const RESET_PIN = 'RESET_PIN';
export const RESET_PIN_SUCCESS = 'RESET_PIN_SUCCESS';

export const FORCE_UPDATE = 'FORCE_UPDATE';
export const FORCE_UPDATE_SUCCESS = 'FORCE_UPDATE_SUCCESS';

export type Platform = string;

export type MetaData = {
    appType: string | 'MOBILE' | 'WEB';
    deviceOS: Platform;
    OSVersion: string;
    deviceName: string;
};

export interface RegisterDeviceReqBody extends MobileLoginBody {
    mobile: string;
    email: string;
}

export type MobileLoginBody = {
    pan?: string;
    pekrn?: string;
    userId?: string;
    deviceId?: string;
    pin?: string;
    metaData: MetaData;
};

export interface ResetDevicePayload extends RegisterDeviceReqBody {
    ids: string[];
}

export interface GetDevicePayload extends RegisterDeviceReqBody { }
